import Vue from 'vue'
import Router from 'vue-router'
import Matrix from './views/Martix/index.vue'
import Punchtheclock from 'components/punch-the-clock/index'
import User from 'components/user/index'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/matrix/punch-the-clock',
      name: 'punch-the-clock',
      component: () => import(/* webpackChunkName: "about" */ './views/Martix/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login/index.vue')
    },
    {
      path: '/matrix',
      name: 'matrix',
      component: Matrix,
      redirect: '/matrix/punch-the-clock',
      children: [
        {
          path: 'punch-the-clock',
          name: 'punch-the-clock',
          component: Punchtheclock
        },
        {
          path: 'user',
          name: 'user',
          component: User
        }
      ]
    }
  ]
})
